import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
  Alert,
} from "react-bootstrap";

const Banners = ({ BannerShow , Act }) => {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      // Adjust the breakpoint according to your needs, for example, 768px for tablets
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const navigate = useNavigate();
  if (BannerShow == 2 && Act) {
    return (
      <div className="container">
         {!isMobile && (
        <div className="ad ad-728x90 my-3">
        <amp-ad
          class="hide-on-mobile"
          width="970"
          height="90"
          type="doubleclick"
          data-slot="/4483046/hc_calc_bottom"
          data-multi-size="728x90"
        ></amp-ad>
        </div>
        )}        
        {isMobile && (
          <div className="ad ad-336x300">
            <amp-ad
              width="336"
              height="300"
              type="doubleclick"
              data-slot="/4483046/hc_calc_bottom"
              data-multi-size="300x250,320x100,320x50"
            ></amp-ad> 
          </div>
        )}

      </div>
    );
  } 

  if(BannerShow == 1 && Act) {
    return (
<>
        {!isMobile && (
        <Col className="col-auto mr-auto" >
          <div className="ad ad-120x600">
            <amp-ad
              width="120"
              height="600"
              type="doubleclick"
              data-slot="/4483046/hc_calc_skyscraper"
            ></amp-ad>
          </div>
        </Col> 
        )}        
</>        

/*       <Col>
        <div style={{ padding: "20px", textAlign: "center" }}>
          <h2>Anuncio AMP1</h2>
          <amp-ad
            width="120"
            height="600"
            type="doubleclick"
            data-slot="/4483046/hc_calc_skyscraper"
          ></amp-ad>
        </div>
      </Col> */
    );
  }
};

// Ejemplo de un componente de React para mostrar un anuncio AMP
const AdComponent = () => {
  return (
    <Col md={8} lg={7}>
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h2>Anuncio AMP</h2>
        <amp-ad
          width="300"
          height="250"
          type="adsense"
          data-ad-client="ca-pub-1234567890123456"
          data-ad-slot="1234567890"
        ></amp-ad>
      </div>
    </Col>
  );
};

export default Banners;
